import { render, staticRenderFns } from "./vuetableFieldCheckboxFixed.vue.html?vue&type=template&id=4dc1435c"
import script from "./vuetableFieldCheckboxFixed.controller?vue&type=script&lang=js&external"
export * from "./vuetableFieldCheckboxFixed.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports